import React, { useState, useRef, useEffect , useReducer} from "react";
import { Modal } from "react-bootstrap";
import { GlobalSet } from '../../global/GlobalProvider';
import { QRCodeCanvas } from "qrcode.react";
import { Link } from "react-router-dom";
import axios from "axios";
//lg
import { useTranslation, initReactI18next } from 'react-i18next';
import i18n from 'i18next';


//** Import Image */
const BasicDatatable = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(
    document.querySelectorAll("#job_data tbody tr")
  );

/** Link */
const initialState = false;
const reducer = (state, action) =>{
  switch (action.type){
    case 'linkModal':
      return { ...state, link: !state.link }    
    default:
      return state  
  } 
}

  const { CurrencySymbol } = GlobalSet();
  const sort = 5;
  const activePag = useRef(0);
  //const [test, settest] = useState(0);

  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  // use effect
  useEffect(() => {
    setData(document.querySelectorAll("#job_data tbody tr"));
   // chackboxFun();
  }, []);

  // Active pagginarion
  activePag.current === 0 && chageData(0, sort);
  // paggination
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  // Active paggination & chage data
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    //settest(i);
  };


 /*.....income data......*/

 const [income, setIncome] = useState([]);
 const [inmydata, MyData] = useState([]);
    useEffect(()=>{
      const auth_token = localStorage.getItem('auth_token');
        const data = {
            key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
        }
      if (auth_token !== null) {
         axios.post('/apps-my-sponsor',data)
         .then(response=>{
           setIncome(response.data.data);
           MyData(response.data.mydata)
           
           })
           .catch(error=>{
             console.log(error)
         })
      }

    },[])


  const [isCopySuccess, setIsCopySuccess] = useState(false);
  const [isRCopySuccess, setIsRCopySuccess] = useState(false);

  const handleCopyClick = () => {
    const linkToCopy = "https://account.bulltraderbd.com/register?ref=" + inmydata.reference_code;
    navigator.clipboard.writeText(linkToCopy)
      .then(() => {
        setIsCopySuccess(true);
        setTimeout(() => {
          setIsCopySuccess(false);
        }, 3000); // 3000 milliseconds (3 seconds)
      })
      .catch((error) => {
        console.error('Error copying to clipboard:', error);
      });
  };

  const handleRCopyClick = () => {
    const linkToCopy = inmydata.reference_code;
    navigator.clipboard.writeText(linkToCopy)
      .then(() => {
        setIsRCopySuccess(true);
        setTimeout(() => {
          setIsRCopySuccess(false);
        }, 3000); // 3000 milliseconds (3 seconds)
      })
      .catch((error) => {
        console.error('Error copying to clipboard:', error);
      });
  };



//** qr code */
  const [url, setUrl] = useState("");
  const qrRef = useRef();
  const downloadQRCode = (e) => {
    e.preventDefault();
    let canvas = qrRef.current.querySelector("canvas");
    let image = canvas.toDataURL("image/png");
    let anchor = document.createElement("a");
    anchor.href = image;
    anchor.download = `qr-code.png`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    setUrl("");
  };
  const qrCodeEncoder = (e) => {
    setUrl(e.target.value);
  };

  const qrcode = (
    <QRCodeCanvas
      id="qrCode"
      value={"https://account.bulltraderbd.com/register?ref="+inmydata.reference_code}
      size={200}
      bgColor={"#000fff00"}
      level={"H"}
    />
  );

  const onInit = () => {
    //console.log('lightGallery has been initialized');
  };
    const options = {
      settings: {
      overlayColor: "#000000",
      },
  };
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <div className="col-12">

            <div className="col-xl-12">
              <div className="row">

                <div className="col-xl-12 col-sm-12">
                  <div className="card booking">
                    <div className="card-body">
                      
                  <div className="input-group mb-3 input-warning">
                    <input
                      type="text"
                      className="form-control"
                      value={"https://account.bulltraderbd.com/register?ref=" + inmydata.reference_code}
                      placeholder="Recipient's username"
                    />
                      <button className="input-group-text" onClick={handleCopyClick}>
                        {t('pro_affi_copy_link')}
                      </button>

                      {isCopySuccess && (
                        <p>Copy successful! The link has been copied to the clipboard.</p>
                      )}


                  </div>
                      
                  <div className="input-group mb-3 input-warning">
                    <input
                      type="text"
                      className="form-control"
                      value={inmydata.reference_code}
                      placeholder="Recipient's username"
                    />
                      <button className="input-group-text" onClick={handleRCopyClick}>
                        {t('pro_affi_copy_link_cd')}
                      </button>
                      {isRCopySuccess && (
                        <p>Copy successful! The link has been copied to the clipboard.</p>
                      )}
                  </div>

                    </div>
                  </div>
                </div>




              </div>
            </div>


      <div className="card">
        <div className="card-header">
          <h4 className="card-title">{t('pro_affi_sp_his')}</h4>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div id="job_data" className="dataTables_wrapper">
              <table
                className="display w-100 dataTable "
                id="example5"
                role="grid"
                aria-describedby="example5_info"
              >
                <thead>
                  <tr role="row">
                    <th className="sorting_asc" style={{ width: "177px" }}>
                      SL
                    </th>
                    <th className="sorting_asc" style={{ width: "177px" }}>
                      {t('pro_affi_name')}
                    </th>
                    <th className="sorting" style={{ width: "278px" }}>
                      Email
                    </th>
                    <th className="sorting" style={{ width: "278px" }}>
                      Self Sell
                    </th>
                    <th className="sorting" style={{ width: "278px" }}>
                      Self And Team
                    </th>
                    <th className="sorting" style={{ width: "278px" }}>
                      Team Sell
                    </th>
                    <th className="sorting" style={{ width: "128px" }}>
                      {t('pro_affi_date')}
                    </th>
                  </tr>
                </thead>

                <tbody>
                {income.map((incomerow, index)=>(
                  <tr key={incomerow.id} className="odd" role="row">
                    <td className="sorting_1">{index + 1}</td>
                    <td className="sorting_1">{incomerow.name ===null ? "Not Verified" : incomerow.name}</td>
                    <td>{incomerow.email}</td>
                    <td>${incomerow.total_invest}</td>
                    <td>${incomerow.team_and_spon_sell}</td>
                    <td>${incomerow.team_sell}</td>
                    <td>{incomerow.created_at}</td>
                  </tr>
                  ))}
                </tbody>
               

              </table>
              <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-md-0 mb-2">
                <div className="dataTables_info">
                  Showing {activePag.current * sort + 1} to{" "}
                  {data.length > (activePag.current + 1) * sort
                    ? (activePag.current + 1) * sort
                    : data.length}{" "}
                  of {data.length} entries
                </div>
                <div
                  className="dataTables_paginate paging_simple_numbers mb-0"
                  id="example5_paginate"
                >
                  <Link
                    className="paginate_button previous disabled"
                    to="/mysponsor-history"
                    onClick={() =>
                      activePag.current > 0 && onClick(activePag.current - 1)
                    }
                  >
                    <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                  </Link>
                  <span>
                    {paggination.map((number, i) => (
                      <Link
                        key={i}
                        to="/mysponsor-history"
                        className={`paginate_button  ${
                          activePag.current === i ? "current" : ""
                        } `}
                        onClick={() => onClick(i)}
                      >
                        {number}
                      </Link>
                    ))}
                  </span>
                  <Link
                    className="paginate_button next"
                    to="/mysponsor-history"
                    onClick={() =>
                      activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1)
                    }
                  >
                    <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDatatable;
